export default __webpack_public_path__ + "static/nav-background-mobile-6664edfdbb26fa6f55d2701b619b6fd5.png";